export default __webpack_public_path__ + "roboto-v27-latin-italic.d52a565af9d2ae4575124c50911a9945.woff2";